module.exports = __webpack_public_path__ + "static/media/stakeLight.7ab67a0d.svg";